/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect, useMemo } from 'react';
import { createItem, deleteItem, getProducts, updateItem } from '../graphql';
import createMultiItems from '../graphql/mutation/createMultiItems';
import _ from 'lodash';

export default (all?: boolean) => {
  const [getprods, itmData]: any = useLazyQuery(getProducts);

  const [addProduct] = useMutation(createItem, {
    refetchQueries: [{ query: getProducts }],
  });
  const [addMultiProducts] = useMutation(createMultiItems, {
    refetchQueries: [{ query: getProducts }],
  });
  const [editProduct] = useMutation(updateItem, {
    refetchQueries: [{ query: getProducts }],
  });
  const [removeProduct] = useMutation(deleteItem, {
    refetchQueries: [{ query: getProducts }],
  });

  useEffect(() => {
    getprods();
  }, [getprods]);

  // const products = itmData?.data?.['getProducts']?.data || [];

  const allProducts = itmData?.data?.['getProducts']?.data || [];

  const refreshproduct = () => itmData?.refetch();

  const products = useMemo(() => {
    return allProducts.filter((pro) => !pro.disabled);
  }, [allProducts]);

  const stockItems = useMemo(() => {
    return products.filter((pro) => pro.quantity > 0);
  }, [products]);

  const fproducts = all ? allProducts : products;

  const total = useMemo(() => {
    return _.sumBy(fproducts, (pro: any) => pro?.cost * pro?.quantity);
  }, [fproducts]);

  return {
    products: all ? allProducts : products,
    allProducts,
    stockItems,
    addProduct,
    addMultiProducts,
    editProduct,
    refreshproduct,
    removeProduct,
    loading: itmData?.loading,
    total,
  };
};
